export default __webpack_public_path__ + "static/media/thi.77bacd3d.png";